import { render, staticRenderFns } from "./Fan.vue?vue&type=template&id=30839c33&scoped=true&"
import script from "./Fan.vue?vue&type=script&lang=js&"
export * from "./Fan.vue?vue&type=script&lang=js&"
import style0 from "./Fan.vue?vue&type=style&index=0&id=30839c33&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30839c33",
  null
  
)

export default component.exports